var _rect, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSecuredLetter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 29,
    viewBox: "0 0 38 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 27,
    transform: "matrix(0.999901 0.0140405 -0.0137372 0.999906 1.14648 0.83374)",
    fill: "url(#pattern0)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_2631_2351",
    transform: "matrix(0.00833333 0 0 0.0111111 0.125 0)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_2631_2351",
    width: 90,
    height: 90,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFoAAABaCAYAAAA4qEECAAAABmJLR0QA/wD/AP+gvaeTAAAEV0lEQVR4nO2cT4xdUxzHv8c0KkQyLaKJTRc2Nk0EC10gEtWRzgYLQSxmyc7GgpV0YYFYkBAi1bKiCRqJWmAjBAskSNCQWEgQUaUznbQ+Fu/deK537/lzz7n3vTe/TzLJTN455/f7fd6Zc+/95eVJhmEYhmEYhmEYhmEYhmEYhmEYRhyu7UVgWdJbkvb2k87c8qmkFefcr00Dzmub7Zz7XdI+Se9kTmyReF/SzW2SJY9oSXLO/SVpVdJrmRJbJI5ptJNP+Qb+RzQw9Shxzm1KukvSoSzpLQYvSbrdObcx7cW6y/qOPgxsmzbROXdO0pqkJ3JkOec8I2nNOXd22ovAkqTnG2cz4k3ggrYowENsXR7zuDkfeBXAJxrgPeBiz4L3A+f6r3Mw/gYe9Di5CDheTQgRDfAJcKln4buBzd5KHY6zwJrHxQ7gg8lJoaIBvgSu8AQ4AJwuXupwbAB3eBzsAj6rT4wRDfA9cKUn0I3AyWKlDsefwC2e2ncD306bHCsa4CdgjyfgNcAv2Usdjt+A6z01XwX82LRAiugsgeeIkI11LZ6NlSoaRv9K+zwJ7Aa+6VzqcIQclTcRcFR2EQ1wBv/F4XKmXBzmgJCL/yqwHrJYV9EQdruzTO12Z8b5GP/t7D1E3M7mEA3hN/BvR647BCEPaA8Q+YCWS3RF8CPpjFKs5ZBbNMDTQGPLFVgCXuiwfimO0NBEG+ftgMdTFy8hunjSBSi+OUqJhvnp/PVy3JUUDbPd+YvuwHWhtGiYzc5fUgeuC32IBviK2en8hXbgPs8ZtC/RMBudv04duC70KRqG7fwN2gjrWzQMU3CWDlwXJmN5P9eRiQslLbcNcM59LekGSScyxDshaa9z7gvPuMsktd4hFaHQG3sGWI3IoWvnz9uBq8W7lcBuXCx9io6SPJFHaufP24HrU3ZfopMkT+QS2/l7F8+DkidedtltwXKxAax4CrsNeNgzZjtwNCDeUWC7Z61HgP2eMSvj3LNQWnSo5KqgJ2n4zN947BLwXEu8Zxl9BKtpvgOeGo9dp0fZJUXHSq54kRZZ43mrjHoQP49/jgMHPHO2AYdqsXqTXUq090wG9tN8Dr6Bp/MXA+0duJBcO5/ZbYun0lVyRacL2kSskA5ccdltC6eQelw08SGwI9GxgJ3AR4Gx1gNyTz5G2haNJddOrvMDcF2C5KuB7wrUkLSzc4nOvZPrnAYeBXYGCL4EOEj6v3mRnZ1DdGnJk5wEXgbuBfYw6hvvGv9+H/AK8EeGONlldxVd6riYBbIeI11EL7LkimyyU0VvBckVWWSniO7lBn/G6FxzrOitKLmiU+0xorey5IpkB6GiTfK/JLkIEW2S/0+0E59ok9xMlJu2QSbZT7CjtgHFOlkLRtDj+uTfrd9AU3+XJL0uKVtzfs7ZlHSnc+5YyOAg0Sa5kWDZXtEm2UuQbN+XV5nkMKKOEcMwDMMwDMMwDMMwDMMwDMMwDCOEfwCb6WcXsn3nBwAAAABJRU5ErkJggg=="
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSecuredLetter);
export default __webpack_public_path__ + "static/media/Secured Letter.ef30602dc3d78272f5dcfa03e5df7a32.svg";
export { ForwardRef as ReactComponent };